<template >

  <div  :key="componentKey" >
    <v-container>

       


      <div class="row">
       <v-jumbotron>
      <v-container fill-height>
        <v-layout align-center>
          <v-flex>
            <h3 class="display-3">{{currentShop.shopName}}</h3>
  
  <br/>
            <span class="subheading">{{currentShop.locationName}},{{currentShop.city}}</span>
  
            <v-divider class="my-3"></v-divider>
  
            <div class="title mb-3">Affordable, fashionable and thrifty fashion options.</div>
  
            <v-btn
              class="mx-0"
              color="primary"
              large
            >
              Contact Shop
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-jumbotron>

        

      </div>
      <div class="row">
        <div class="col-sm-12 col-xs-12 col-md-12">
          
          <v-card-text class="pa-0 pt-4" tile outlined>
            <p class="subtitle-1 font-weight-light pt-3 text-center blue lighten-5 ma-mdd-2">
              YOU MIGHT ALSO LIKE
            </p>
            <v-divider></v-divider>
            <div class="row text-center">
              <div
                v-for="product in similarProducts"
                :key="product.key"
                class="col-md-3 col-sm-4 col-xs-12 text-center"
              >
                <v-hover v-slot:default="{ hover }" open-delay="200">
                  <v-card :elevation="hover ? 16 : 2" 
                   :to="{
                          name: 'Product',
                          params: { productId: product.key }
                        }"
                        @click="refreshSelf(product.key)">
                    <v-img
                      class="white--text align-end"
                       :aspect-ratio="16 / 9"
                       height="100px"
                      :src="product.data.imageUrl"
                    >
                      <v-card-title>{{ product.data.itemName }}</v-card-title>
                    </v-img>

                    <v-card-text class="text--primary text-center">
                      <div>Ksh. {{ product.data.itemCategory }}</div>
                      <div>Ksh. {{ formatPrice(product.data.itemPrice) }}</div>
                    </v-card-text>

                   
                  </v-card>
                </v-hover>
              </div>
            
            </div>
          </v-card-text>
        </div>
      </div>
    </v-container>
     
  </div>
</template>
<script> 
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/satellite-min.css';
import { mapState, mapActions } from "vuex";  

export default {
  created() {
     window.scrollTo(0, 0);
   // this.$store.dispatch("doAdder");
   // this.$store.dispatch("getCurr");
   // this.$store.dispatch("getProducts");
   // this.$store.dispatch("getCategories");
   // this.$store.commit("setId", this.$route.params.productId);
    //this.$store.commit("setCurr", this.$route.params.productId);
    this.$store.commit("setCurrentShop",this.$route.params.productId);
    this.$store.commit("setCurrentShopProducts");
  },
  computed: { 
     
    mapState:mapState ({
      count: state => state.count,
      curr: state => state.curr,
      currId: state => state.currId
    }),
    currentProduct() {
      return this.$store.state.curr;
    },

    currentShop() {
      return this.$store.state.currentShop;
    },

    similarProducts() {
      return this.$store.state.currentShopProducts;
    }
  },

  data: () => ({
    componentKey: 0,
      searchClient: algoliasearch(
        '3AV9AUVNSM',
        'f82adba3bcff8507a51e40c9d21e1f6a'
      ),
       rules: {
          required: value => !!value || 'Required.', 
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
    amount: 0,
    rating: 4.5,
    firstName: "",
    lastName: "",
    phoneNumber: "",
    emailAddress: "",
     
    item: 5,
    items: [],
    errors:[],

    dialog: false
  }),
  methods: {
    saveUserData(priceAmount) {
   this.errors = [];
         if (this.firstName && this.lastName && this.phoneNumber && this.emailAddress) {
        this.makePayment(priceAmount);
         
       console.log(  this.firstName +
        this.lastName +
        this.phoneNumber +
        this.emailAddress + 'as form data');

        const user = {
            firstName:this.firstName,
        lastName:this.lastName,
        phoneNumber:this.phoneNumber,
        emailAddress:this.emailAddress
        }
      
      this.$store.commit(
        "setUser",
        user
      );
      
       this.dialog = false; 
       }
      
      if(!this.firstName){this.errors.push("First Name is required!")}
      if(!this.lastName){this.errors.push("Last Name is required!")}
      if(!this.phoneNumber){this.errors.push("Phone number is required!")}
      if(!this.emailAddress){this.errors.push("Email address is required!")}
    },
    refreshSelf(key) {
    
      this.$store.commit("setId", key);
      this.$store.commit("setCurr", this.$store.getters.productList[key]);
      console.log("data from shop" + this.$store.getters.productList[key]);
      console.log("current key is:" + this.$store.state.currId);
      console.log("current curr is:" + this.$store.state.curr);
      window.scrollTo(0, 0);
    },

    resetSearch() { 

      //this method is not being users due to errors
        document
        .querySelectorAll('.ais-SearchBox-input')
        .forEach((e) => (e.value = ''))

      // clear all the hits
      document.querySelectorAll('.ais-Hits-item').forEach((e) => e.remove())

      // also clear the hits from the component, otherwise subsequent searches throw exceptions
    this.$refs.searchHits.state.hits = []
  
     this.componentKey += 1;
     
  },


    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    makePayment(priceAmount) {
      this.amount = priceAmount;
      this.$launchFlutterwave({
        tx_ref: Date.now(),
        amount: this.amount,
        currency: "KES",
        payment_options: "card,mobilemoney",
        customer: {
          email: this.emailAddress,
          phonenumber: this.phoneNumber,
          name: this.firstName +" " +this.lastName,
        },
        callback: function(response) {
          // specified callback function
          console.log("the response is: "+ response);

          /**
           * save to firebase 
           * response message as an object 
           */
        },
         onclose: function(){
           console.log("modal closed!");
         },
        customizations: {
          title: "Sendsoko",
          description: "Payment for products from sendsoko",
          logo: "https://assets.piedpiper.com/logo.png"
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/My-Shop.vue